import React from 'react';

import classNames from 'classnames';

import Box from '@cobalt/react-box';

export interface TabPaneProps {
  dataPrefix?: string;
  prefixCls?: string;
  id?: string;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;

  tab: React.ReactNode;
  tabKey?: string;
  key: string;
  disabled?: boolean;
}

function TabPane(props: TabPaneProps) {
  const { prefixCls, id, className, style, children, tabKey } = props;

  const componentCls = `${prefixCls}-tab-pane`;
  const mergeClassNames = classNames(`${componentCls}`, className);

  return (
    <Box id={id && `tab-panel-${id}-${tabKey}`} className={mergeClassNames} style={style}>
      {children}
    </Box>
  );
}

TabPane.displayName = 'TabPane';

export default TabPane;
